"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thriftSavingsPlans = exports.taxExemptRetirementAccounts = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var taxExemptRetirementAccounts = function taxExemptRetirementAccounts(idCounter, stateCode) {
  return {
    id: idCounter.increment(),
    description: 'Tax Exempt Retirement Accounts',
    type: stateCode,
    statuteName: '11 U.S.C. § 522(b)(3)(C)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.RETIREMENT_401K || subType === _subTypes.RETIREMENT_403B || subType === _subTypes.IRA);
    }
  };
};

exports.taxExemptRetirementAccounts = taxExemptRetirementAccounts;

var thriftSavingsPlans = function thriftSavingsPlans(idCounter, stateCode) {
  return {
    id: idCounter.increment(),
    description: 'Thrift Savings Plan',
    type: stateCode,
    statuteName: '5 U.S.C. §§ 8437(e)(g), 11 U.S.C. § 541(c)(2)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.THRIFT_SAVINGS_PLAN;
    }
  };
};

exports.thriftSavingsPlans = thriftSavingsPlans;